<template>
  <div class="thinking-indicator">
    <AiAvatar with-pulse />
    <span class="text">Thinking...</span>
  </div>
</template>

<script setup>
import AiAvatar from "./AiAvatar.vue";
</script>

<style scoped>
.thinking-indicator{align-items:center;display:flex;gap:12px;max-width:80%}.text{animation:textPulse 1.5s ease-in-out infinite;color:#6b7280;font-style:italic}@keyframes textPulse{0%,to{opacity:1}50%{opacity:.4}}
</style>
